// export default 'http://39.105.41.16:8011'
export default 'http://39.105.41.16:8011'
